import { tokens } from '@sail/ui';
export const border = {
    radius: {
        action: tokens.border.radius.rounded
    }
};

//# sourceMappingURL=border.js.map